export default [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ './Home.vue'),
    props: (route) => ({ id: route.query.client_id })
  }
]
